// Internal, admin-only identity search. This does not enable the tenant's D&B flag.
export const DNB_IDENTITY_SEARCH_TENANT_ID = 'Gyn7VXYnZI9JGEcFC02B';
export const isDnbIdentitySearchTenant = tenantId => tenantId === DNB_IDENTITY_SEARCH_TENANT_ID;
